export const STORES = {
  1: {
    name: "Egypt",
    currency: "EGP",
    currencyName: "Egyptian Pound",
    countryCode: "EG",
  },
  //TESTING VPN
  // 2: {
  //   name: "Netherlands",
  //   currency: "EUR",
  //   currencyName: "Euro",
  //   countryCode: "NL",
  // },
  //TESTING VPN
  3: {
    name: "United Arab Emirates",
    currency: "AED",
    currencyName: "UAE Dirham",
    countryCode: "AE",
  },
  4: {
    name: "Saudi Arabia",
    currency: "SAR",
    currencyName: "Saudi Riyal",
    countryCode: "SA",
  },
};

const DEFAULT_STORE_ID = 1;

export const getCurrentStore = () => {
  const stored = JSON.parse(localStorage.getItem("store") || "{}");
  if (stored?.id && STORES[stored.id]) {
    return stored;
  }
  const fallback = { id: DEFAULT_STORE_ID, ...STORES[DEFAULT_STORE_ID] };
  localStorage.setItem("store", JSON.stringify(fallback));
  return fallback;
};

// Map country codes to store objects dynamically
export const getStoresByCountryCode = () => {
  const map = {};
  Object.values(STORES).forEach((store) => {
    map[store.countryCode] = store;
  });
  return map;
};
